module.exports = __webpack_public_path__ + "static/media/img_item_08.fcf061f0.png";